import { utils } from '@ohif/core';

const { studyMetadataManager } = utils;

// MPR/volume rendering need a proper 3D volume (multiple slices with known
// spacing/orientation) — only true for reconstructable series (CT/MR),
// not for single images, secondary captures, US, etc.
export default function isDisplaySetReconstructable(
  viewportSpecificData = {},
  activeViewportIndex
) {
  if (!viewportSpecificData[activeViewportIndex]) {
    return false;
  }

  const { displaySetInstanceUID, StudyInstanceUID } = viewportSpecificData[
    activeViewportIndex
  ];

  const studies = studyMetadataManager.all();

  const study = studies.find(
    study => study.studyInstanceUID === StudyInstanceUID
  );

  if (!study) {
    return false;
  }

  const displaySet = study._displaySets.find(
    set => set.displaySetInstanceUID === displaySetInstanceUID
  );

  if (!displaySet) {
    return false;
  }

  return displaySet.isReconstructable;
}
